import { render } from "./add-note.vue?vue&type=template&id=c84137c6&scoped=true"
import script from "./add-note.vue?vue&type=script&lang=js"
export * from "./add-note.vue?vue&type=script&lang=js"

import "./add-note.vue?vue&type=style&index=0&id=c84137c6&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84137c6"]])

export default __exports__